import React from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import TabBar from "@/components/TabBar";
import { ViewSwitchHeader } from "@/components/ViewSwitchHeader";
import FirstLoginSetup from "@/components/FirstLoginSetup";
import "@/components/FirstLoginSetup.css";

export default function DashboardLayout() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Forced first-login: anyone still flagged must set a password before entering.
  // Keyed off the authenticated account's own flag, so admin preview is unaffected.
  if (user && user.must_change_password) {
    return <FirstLoginSetup />;
  }

  const handleLogoClick = () => {
    // Logo always navigates to role's home
    navigate("/");
  };

  // Immersive / self-chromed surfaces: hide the shared header + tab bar.
  // - Employee Home (index) renders its own espresso header + frosted tab bar.
  // - Check-In is a full-screen experience (no tab bar collision).
  const viewingAsEmployee =
    user?.role !== "administrator" ||
    user?.active_view === "preview_employee" ||
    user?.active_view === "self_employee";
  const isEmployeeHome = location.pathname === "/" && viewingAsEmployee;
  const isImmersive = location.pathname === "/employee/check-in";
  const hideChrome = isEmployeeHome || isImmersive;

  return (
    <div className="min-h-screen bg-background">
      {user?.role === 'administrator' && <ViewSwitchHeader />}
      {!hideChrome && (
        <header className="bg-card border-b border-border sticky top-0 z-50" data-testid="dashboard-header">
          <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
            <button
              onClick={handleLogoClick}
              className="text-left"
            >
              <h1 className="text-xl font-medium text-foreground">GT L.A.B Careers</h1>
              <p className="text-xs text-muted-foreground">GT Lash & Brows</p>
            </button>
            <div className="text-right">
              <div className="text-sm font-medium text-foreground">{user?.display_name || user?.name}</div>
              <div className="text-xs text-muted-foreground capitalize">{user?.employment_role || user?.role}</div>
            </div>
          </div>
        </header>
      )}
      <main className={hideChrome ? "" : "pb-16"}>
        <Outlet />
      </main>
      {!hideChrome && <TabBar />}
    </div>
  );
}
